import { useState, useCallback } from "react";
import AuthContext from "./authContext";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({
    id: "",
    role: "",
    uuid: "",
    first_name: "",
    last_name: "",
  });

  const setUserData = useCallback(
    ({ id, role, uuid, first_name, last_name }) => {
      setUser((prev) => {
        if (
          prev.id === id &&
          prev.role === role &&
          prev.uuid === uuid &&
          prev.first_name === first_name &&
          prev.last_name === last_name
        ) {
          return prev;
        }
        return { id, role, uuid, first_name, last_name };
      });
    },
    [],
  );

  const setRole = useCallback((role) => {
    setUser((prev) => ({ ...prev, role }));
  }, []);

  const clearUser = useCallback(() => {
    setUser({ id: "", role: "", uuid: "", first_name: "", last_name: "" });
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUserData, setRole, clearUser }}>
      {children}
    </AuthContext.Provider>
  );
};
